import {FC} from 'react'

type Props = {
  data: string
}

const HrItemEmployee: FC<Props> = ({data}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3'>
        <span className='small text-gray-900'>{data}</span>
      </div>
    </div>
  )
}

export {HrItemEmployee}
